import { useStaticQuery, graphql } from "gatsby";
import { UseFirstLastDepartureCruiseQuery } from "types/graphql-types";

export const useFirstLastDepartureCruise = (): {
  minYearMonth?: string;
  maxYearMonth?: string;
} => {
  const results = useStaticQuery<UseFirstLastDepartureCruiseQuery>(graphql`
    query UseFirstLastDepartureCruise {
      min: allSanityCruise(
        sort: { fields: data___departureDate, order: ASC }
        filter: {
          data: { departureDate: { ne: null }, isVisible: { eq: true } }
        }
        limit: 1
      ) {
        nodes {
          data {
            departureYearMonth
          }
        }
      }
      max: allSanityCruise(
        sort: { fields: data___departureDate, order: DESC }
        filter: {
          data: { departureDate: { ne: null }, isVisible: { eq: true } }
        }
        limit: 1
      ) {
        nodes {
          data {
            departureYearMonth
          }
        }
      }

      maxVisibilityFalse: allSanityCruise(
        sort: { fields: data___departureDate, order: DESC }
        filter: { data: { departureDate: { ne: null } } }
        limit: 1
      ) {
        nodes {
          data {
            departureYearMonth
          }
        }
      }
    }
  `);

  const { min, max, maxVisibilityFalse } = results;
  const targetMaxDate =
    process.env.GATSBY_SHOW_ALL_FUTURE_CRUISES == "true"
      ? maxVisibilityFalse
      : max;

  return {
    minYearMonth: min.nodes[0]?.data?.departureYearMonth,
    maxYearMonth: targetMaxDate.nodes[0]?.data?.departureYearMonth
  };
};
